<template>
    <div class="bootstrap modal-content">
      <el-form @submit.native.prevent="submitForm('ruleForm')" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px">
      <div class="modal-header">
        <h5 class="modal-title text-info">광고주담당자 회원 {{modeName}}</h5>
        <button type="button" class="close" @click="$emit('dismiss')">X</button>
      </div>
      <div class="modal-body p-3">


                <el-form-item v-if="!isSelectCompany" label="업체명">
                  <span class="text-primary2 fs18 ml-3">{{ruleForm.companyName || companyInfo.companyName}}</span>
                </el-form-item>

                <el-form-item v-if="isSelectCompany" label="광고주" prop="companySeq" required>
                  <el-row :gutter="12">
                      <search-company
                        cls="pl-0"
                        v-model="ruleForm.companySeq"
                        :is-user-company="true"
                        :keyword-span="5"
                        :company-span="12"
                        :showLabel="false"
                        @selected="companySelected"
                      >
                      </search-company>
                    </el-row>
                </el-form-item>

                <el-form-item v-if="mode === 'edit'" label="아이디 (이메일)">
                  <span class="text-primary2 fs18 ml-3">{{ruleForm.userId}}</span>
                </el-form-item>

                <hr class=""/>

                <el-form-item v-if="mode === 'insert'" label="아이디 (이메일)" required>
                  <el-col :span="6">
                    <el-form-item prop="emailId" ref="emailId">
                      <el-input v-model="ruleForm.emailId" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col class="text-center" :span="2">@</el-col>
                  <el-col :span="6">
                    <el-form-item prop="emailDomain" ref="emailDomain">
                      <el-input v-model="ruleForm.emailDomain" ></el-input>
                    </el-form-item>
                  </el-col>
                </el-form-item>

                <el-form-item label="이름" prop="userName" required>
                  <el-input v-model="ruleForm.userName" ></el-input>
                </el-form-item>

                <div v-if="mode==='insert'">
                <el-form-item label="비밀번호" prop="password" required>
                  <el-input type="password" v-model="ruleForm.password" ></el-input>
                </el-form-item>
                <el-form-item label="비밀번호 확인" prop="confirmPassword" required>
                  <el-input type="password" v-model="ruleForm.confirmPassword" ></el-input>
                </el-form-item>
                </div>

                <el-form-item v-if="ruleForm.masterYn === 'N'" label="부서" prop="department" required>
                  <el-input v-model="ruleForm.department" ></el-input>
                </el-form-item>

                <el-form-item label="휴대폰" prop="phone1" required>
                  <tel-input v-model="ruleForm.phone1" ></tel-input>
                </el-form-item>

                <el-form-item label="사무실번호" prop="phone2">
                  <tel-input v-model="ruleForm.phone2" ></tel-input>
                </el-form-item>


                <el-form-item label="상태" >
                <el-select v-model="ruleForm.status">
                  <el-option
                    label="정상"
                    value="OK"></el-option>
                  <el-option v-if="mode==='edit'"
                    label="삭제"
                    value="REMOVE"></el-option>
                  <el-option 
                    label="승인대기중"
                    value="READY"></el-option>
                </el-select>
              </el-form-item>


      </div>
    <div class="modal-footer">
        <!-- <el-button v-if="mode == 'edit'" @click="resetPwd" style="position:absolute;left:20px" type="warning" icon="el-icon-lock">비밀번호 초기화</el-button> -->
        <el-button native-type="submit" class="ml-4" type="primary" icon="el-icon-check">저 장</el-button>
        <el-button @click="$emit('dismiss')">닫 기</el-button>
    </div>
  </el-form>
</div>

</template>

<script>
  import CommonProxy from '@/proxies/CommonProxy';
  import * as Util from '@/util/util'
  import _ from 'lodash'
  import AccountsProxy from '@/proxies/AccountsProxy';
  import SearchCompany from '../Common/SearchCompany.vue';
  import TelInput from '@/components/Pages/Views/Common/TelInput.vue'

  const validator = ({required, onlyWord, domain, min, pwd, confirmPassword, phone,  tel, idValid}, vm) => {

    return function(rule, value, callback){

      
      if(required && !value) {
        callback( new Error('필수입력 항목입니다.'))
        return
      } else if(onlyWord && !/^[\w\-\.]+$/g.test(value) ) {
          callback( new Error('영문만 가능합니다.'))
          return
      } else if(domain && !/[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(value) ) {
          callback( new Error('이메일 형식만 가능합니다. ex)gmail.com'))
          return
      } else if(min && value.length < min ) {
          callback( new Error(`최소 ${min}자리 이상 이어야 합니다.`))
          return
      } else if(pwd && !/^(?=.*?[#?!@$ %^&*-]).{6,}$/.test(value)) {
        callback( new Error(`특수 문자 포함 6자 이상 입력하세요.`))
        return

      } else if(confirmPassword && value !== vm.ruleForm[confirmPassword] ) {
          callback( new Error('비밀번호가 일치하지 않습니다.'))
          return
      } else if(phone  && !/^\d+\-\d+\-\d+$/g.test(value) ) {
          callback( new Error('필수이고 숫자만 가능합니다.'))
          return
      } else if(tel && value &&  !/^\d*\-\d*\-\d*$/g.test(value) ) {
          callback( new Error('숫자만 가능합니다.'))
          return
      } else if(idValid) {
          vm.idValid( value, callback )

      } else {
        callback()
      }

      
    }

  } 

  export default {
    components: {
      TelInput,
      SearchCompany
    },
    props: {
      mode: {
        type: String,
      },
      userId: {
        type: String,
      },
      companyInfo: {
        default() {
          return {
            companyName: ''
          }  
        },
        type: Object
      }, 
      changeRecord: {
        type: Function
      },
      isSelectCompany: {
        type: Boolean,
        default: false
      }
    },
    created() {
      this.debouncedCaptchaAnswer = _.debounce(this.idValid, 800)

      this.modeName = (this.mode === 'insert')? '추가등록': '정보수정' 

      if(this.mode === 'edit') {
        new AccountsProxy().find( this.userId )
        .then( res => { 
          const {userId, userName, roleCode, companyName, companySeq, email, phone1, phone2, status, department, masterYn} = res.user
          const data = {userId, userName, roleCode, companyName, companySeq, email, phone1, phone2, status, department, masterYn}
          this.ruleForm = {...data} 
        })
      } else {
        this.ruleForm.companySeq = this.companyInfo.companySeq
        this.ruleForm.roleCode = this.companyInfo.roleCode
      }

      console.log(this.ruleForm.companySeq)


    },
    mounted() {

    },
    methods: {
        companySelected( {roleCode}) {
          this.ruleForm.roleCode = roleCode
        },
        idValid( value, callback ) {
            new CommonProxy()
            .existsUserId( this.email )
            .then(response => {
              if(!response.success) {
                callback( new Error('동일한 아이디가 존재합니다.'))
              } else {
                this.$refs.emailId.clearValidate()
                this.$refs.emailDomain.clearValidate()
                callback()
              }

            })

        },
        submitForm(formName) {

            this.$refs[formName].validate((valid) => {
              if (valid) {
                  let promise;
                  const proxy = new AccountsProxy()

                  if(this.mode ==='edit') {
                    promise = proxy.updateSubUser( this.ruleForm )
                  } else {
                    promise = proxy.createSubUser( this.ruleForm )
                  }

                  promise.then(response => {
                    if(response.header.returnCode !== 'OK') {
                      alert(response.header.resultMessages)
                    } else {
                      alert('저장 되었습니다.')
                      if(this.changeRecord) {
                        this.changeRecord( this.ruleForm )
                      }  
                      this.$emit('close')
                    }
                  })

              } else {
                  alert('필수 항목들을 빠짐없이 입력해 주세요')
                  return false;
              }
            })
        },
        existsUserId() {
          //const vm = this
          new CommonProxy().existsUserId( this.email )
          .then(response => {
          })
        },
        changeCaptchaUrl() {
          this.captcha = '/api/common/captcha' + '?' + Util.random(1,10000)
          return this.captcha
        },
        resetPwd() {

          if(!confirm('비밀번호를 초기화 하시겠습니까?\n\n사용자의 이메일로 비밀번호초기화 안내 메일이 발송됩니다.')) {
            return
          }  

          new CommonProxy()
            .resetPwdByAdmin( this.userId )
            .then(response => {
              if(!response.success) {
                if(!response.found) {
                  alert('해당하는 사용자를 찾을 수 없습니다.')
                } else if(!response.email) {
                  alert('이메일이 없는 사용자 입니다.')
                }  

              } else {
                alert('사용자의 이메일로 비밀번호초기화 안내메일을 전송했습니다.')
              }
          })

        },
        changeEmail() {
          if(this.mode === 'insert') {
            this.ruleForm.email = this.ruleForm.emailId + '@' + this.ruleForm.emailDomain
            this.ruleForm.userId = this.ruleForm.email
          }
        }

    },
    computed: {
      email() {
        this.ruleForm.email = this.ruleForm.emailId+'@'+this.ruleForm.emailDomain
        this.ruleForm.userId = this.ruleForm.email
        return this.ruleForm.email
      },
    },
    
    watch: {
      'ruleForm.emailId' : {
        deep: true,
        handler() {
          this.changeEmail()
        }
      },
      'ruleForm.emailDomain' : {
        deep: true,
        handler() {
          this.changeEmail()
        }
      },

    },
    data() {
      return {
        ruleForm: {
          companySeq: '',
          userId: '',
          email: '',
          emailId: '',
          emailDomain: '',
          password: '',
          confirmPassword: '',
          userName: '',
          department: '',
          phone1: '',
          phone2: '',
          masterYn: 'N',
          status: 'OK'
        },
        rules: {
          companySeq: [{ trigger: "change", validator: validator({ required: true }) }],
          
          emailId: [
            { trigger: 'blur', validator: validator({ required: true, onlyWord: true, idValid: true }, this) },
            { trigger: 'change', validator: validator({ required: true, onlyWord: true, idValid: true }, this) }
          ],
          emailDomain: [
            { trigger: 'blur', validator: validator({ required: true, domain: true, idValid: true }, this) },
            { trigger: 'change', validator: validator({ required: true, domain: true, idValid: true }, this) }
          ],
          password: [
            { trigger: 'blur', validator: validator({ required: true, pwd: true }) },
            { trigger: 'change', validator: validator({ required: true, pwd: true }) }
          ],
          confirmPassword: [
            { trigger: 'blur', validator: validator({ required: true, confirmPassword: 'password' }, this) },
            { trigger: 'change', validator: validator({ required: true, confirmPassword: 'password'}, this) }
          ],
          userName: [
            { trigger: 'blur', validator: validator({ required: true}) },
            { trigger: 'change', validator: validator({ required: true}) },
          ],
          department: [
            { trigger: 'blur', validator: validator({ required: true}) },
            { trigger: 'change', validator: validator({ required: true}) },
          ],
          phone1: [
            { trigger: 'input', validator: validator({ required: true, phone: true}) },
            { trigger: 'blur', validator: validator({ required: true, phone: true}) }
          ],
          phone2: [
            { trigger: 'input', validator: validator({ tel: true}) },
            { trigger: 'blur', validator: validator({ tel: true}) }
          ],

        }
      }
    }
  }
</script>

<style scoped>
.el-form-item {
    margin-bottom: 22px !important;
}
</style>
